var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3312_13264)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3312_13264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1276 2.08398H16.8776C20.2109 2.08398 22.9193 4.79232 22.9193 8.12565V16.8757C22.9193 18.478 22.2827 20.0147 21.1497 21.1478C20.0167 22.2808 18.48 22.9173 16.8776 22.9173H8.1276C4.79427 22.9173 2.08594 20.209 2.08594 16.8757V8.12565C2.08594 6.5233 2.72247 4.98658 3.8555 3.85355C4.98853 2.72052 6.52526 2.08398 8.1276 2.08398ZM7.91927 4.16732C6.92471 4.16732 5.97088 4.56241 5.26762 5.26567C4.56436 5.96893 4.16927 6.92276 4.16927 7.91732V17.084C4.16927 19.1569 5.84635 20.834 7.91927 20.834H17.0859C18.0805 20.834 19.0343 20.4389 19.7376 19.7356C20.4409 19.0324 20.8359 18.0785 20.8359 17.084V7.91732C20.8359 5.8444 19.1589 4.16732 17.0859 4.16732H7.91927ZM17.9714 5.72982C18.3167 5.72982 18.6479 5.867 18.8921 6.11119C19.1363 6.35538 19.2734 6.68657 19.2734 7.0319C19.2734 7.37724 19.1363 7.70843 18.8921 7.95261C18.6479 8.1968 18.3167 8.33398 17.9714 8.33398C17.626 8.33398 17.2948 8.1968 17.0506 7.95261C16.8065 7.70843 16.6693 7.37724 16.6693 7.0319C16.6693 6.68657 16.8065 6.35538 17.0506 6.11119C17.2948 5.867 17.626 5.72982 17.9714 5.72982ZM12.5026 7.29232C13.8839 7.29232 15.2087 7.84105 16.1855 8.8178C17.1622 9.79456 17.7109 11.1193 17.7109 12.5007C17.7109 13.882 17.1622 15.2067 16.1855 16.1835C15.2087 17.1603 13.8839 17.709 12.5026 17.709C11.1213 17.709 9.79651 17.1603 8.81976 16.1835C7.843 15.2067 7.29427 13.882 7.29427 12.5007C7.29427 11.1193 7.843 9.79456 8.81976 8.8178C9.79651 7.84105 11.1213 7.29232 12.5026 7.29232ZM12.5026 9.37565C11.6738 9.37565 10.8789 9.70489 10.2929 10.2909C9.70684 10.877 9.3776 11.6719 9.3776 12.5007C9.3776 13.3295 9.70684 14.1243 10.2929 14.7104C10.8789 15.2964 11.6738 15.6257 12.5026 15.6257C13.3314 15.6257 14.1263 15.2964 14.7123 14.7104C15.2984 14.1243 15.6276 13.3295 15.6276 12.5007C15.6276 11.6719 15.2984 10.877 14.7123 10.2909C14.1263 9.70489 13.3314 9.37565 12.5026 9.37565Z",
    fill: "#959595"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3312_13264",
    x: -1.91406,
    y: -1.91602,
    width: 28.8359,
    height: 28.834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3312_13264"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3312_13264",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3312_13264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.72d57eca1389dbc05f77514d2d8cdb73.svg";
export { ForwardRef as ReactComponent };